// extracted by mini-css-extract-plugin
export default {"main":"Privacy_main__TOr50"};